<template>
    <b-form-group :label="required ? null : label"
                  :label-html="required ? requiredLabelHtml : null"
                  :invalid-feedback="errorTxt"
                  :state="state">
        <b-form-input
                v-model="inputVal"
                :type="type"
                :state="state"
                :placeholder="placeholder"
                :readonly="readonly"
                @change="$emit('change', $event)">
        </b-form-input>
    </b-form-group>
</template>

<script>
    export default {
        props: ['model', 'attribute', 'label', 'type', 'placeholder', 'errors', 'readonly', 'errorOnly', 'required'],
        data() {
            return {inputVal: this.model[this.attribute] ? this.model[this.attribute] : null, state: null, errorTxt: ''}
        },
        computed: {
            // Nhãn kèm dấu * đỏ cho trường bắt buộc (chỉ dùng khi required=true)
            requiredLabelHtml() {
                return (this.label || '') + ' <span class="text-danger">*</span>';
            }
        },
        watch: {
            model: {
                handler(val) {
                    this.state = null;
                    this.errorTxt = '';
                    this.inputVal = val[this.attribute];
                }, deep: true
            },
            inputVal(val) {
                this.state = null;
                this.errorTxt = '';
                this.model[this.attribute] = val;
            },
            errors(val) {
                let hasErr = false;
                if (val.length) {
                    val.forEach(v => {
                        if (v.param === this.attribute) {
                            this.state = false;
                            this.errorTxt = v.msg;
                            hasErr = true;
                        }
                    });
                }
                if (!this.errorOnly) {
                    this.state = !hasErr;
                }
            }
        },
    }
</script>